import { useCallback, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'

import { getAvailableLanguages } from 'config/i18n/common'
import { setLanguage } from 'redux/features/app/appSlice'
import { FEATURES } from 'lib/splitioFeatures'

export interface UseLanguageMenuDialogLogic {
  selectedLanguage: string
  handleSelectLanguage: (currentLanguage: string) => void
  availableLanguages: Array<{ label: string; code: string }>
}

export const useLanguageMenuDialogLogic = () => {
  const dispatch = useAppDispatch()
  const { preferredLanguage, isSplitioInitialized } = useAppSelector(_store => ({
    preferredLanguage: _store.app.language,
    isSplitioInitialized: Object.keys(_store.splitio?.treatments || {}).length === Object.keys(FEATURES).length
  }))

  const languageOptions = useMemo(() => {
    const languages = getAvailableLanguages()
    const languageCodes = Object.keys(languages)

    if (!isSplitioInitialized && languageCodes.length === 0) {
      return []
    }

    return languageCodes.map(code => ({
      label: languages[code as keyof typeof languages] || code,
      code
    }))
  }, [isSplitioInitialized])

  const handleSelectLanguage = useCallback(
    (currentLanguage: string) => {
      dispatch(setLanguage(currentLanguage))
    },
    [dispatch]
  )

  return {
    selectedLanguage: preferredLanguage,
    handleSelectLanguage,
    availableLanguages: languageOptions
  }
}
